import { DesignSystem } from '@workbuddy/ui/v2/design-system';

// Design values for the bulk "Add comment" composer: the textarea and the line under it. Scoped to the
// dialog element so the shared page chrome around it keeps its own.

const tokens = DesignSystem.tokens;

export const itemCommentBulkDialogStyleId = 'job-item-comment-bulk-dialog-theme';

export const itemCommentBulkDialogBridgeStyles = {
  'item-comment-bulk-dialog': {
    '--local-comment-body-width': '560px',
    '--local-comment-gap': tokens.spacing.md,
    '--local-comment-padding': tokens.spacing.lg,
    '--local-comment-radius': tokens.radius.md,
    '--local-comment-border': tokens.color.border.primary,
    '--local-comment-border-focus': tokens.color.border.brand,
    '--local-comment-color': tokens.color.text.primary,
    '--local-comment-placeholder-color': tokens.color.text.placeholder,
    '--local-comment-size': tokens.font.size.textSm,
    '--local-comment-note-color': tokens.color.text.tertiary,
    '--local-comment-note-size': tokens.font.size.textXs,
  },
};
